<template>
  <div class="contents_wrapper">
    <ClientScoreBox :client="client"/>
    <div class='contents'>
      <p class="large_white_label">クライアントマイページ</p>

      <ClientButtonBlock/>
    </div>
  </div>
</template>

<script>
  import ClientTop from "@/assets/js/pages/mypage/client/ClientTop";
  import {mapGetters} from "vuex";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import collection from "@/assets/js/functions/firebase/firestore/collection";

  import ClientButtonBlock from "@/components/objects/block/mypage/ClientButtonBlock";
  import ClientScoreBox from "@/components/molecules/box/ClientScoreBox";

  export default {
    name: "ClientTop",

    components: {ClientScoreBox, ClientButtonBlock},

    mixins: [ClientTop, collection],

    data() {
      return {
        client: {},
        matching: {},
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(COLLECTION_NAMES.CLIENTS, this.uid).then(async doc => {
        this.client = doc;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    }
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $client_primary;

    > .contents {
      @include contents();
      margin-bottom: 4rem;

      .large_white_label {
        width: 65%;
      }

      > .client-button_block {
        width: 70%;
      }
    }
  }
</style>